import type { PortalMessage } from '@central/api';

/** The longest message body the server takes, in code points after trimming. */
export const MAX_BODY = 20_000;

/**
 * Internal notes are never sent to the portal; any message carrying
 * `internal: true` is dropped here as well, so a server mistake cannot show
 * one to a customer.
 */
export function customerVisible(messages: PortalMessage[]): PortalMessage[] {
  return messages.filter((m) => (m as { internal?: unknown }).internal !== true);
}
